import { Pipeline } from "../types/pipelineProperties";
import { AssetStatus, ContentRowInformation, JobType, Status } from "../types/statusTypes";

export function mapToStatus(contentStatuses: ContentRowInformation) {
  return {
    contentId: contentStatuses.contentId,
    version: contentStatuses.version,
    redbeeStatus: getStatus(contentStatuses.redbeeStatus),
    apolloStatus: getStatus(contentStatuses.apolloStatus),
    hbbtvStatus: getStatus(contentStatuses.hbbtvStatus),
    hydraDashStatus: getStatus(contentStatuses.hydraDashStatus),
    hydraHlsStatus: getStatus(contentStatuses.hydraHlsStatus),
  } as ContentRowInformation;
}

export function getStatus(status: string): Status {
  switch (status) {
    case "STATUS.COMPLETE":
      return Status.Complete;
    case "STATUS.FAILED":
      return Status.Failed;
    case "STATUS.IN_PROGRESS":
      return Status.InProgress;
    case "STATUS.PENDING":
      return Status.Pending;
    case "STATUS.REVOKED":
      return Status.Revoked;
    default:
      return Status.Empty;
  }
}

export function getStatusDisplayText(statusText: Status) {
  switch (statusText) {
    case Status.InProgress:
      return "In Progress";
    case Status.Empty:
      return "";
    default:
      return statusText.charAt(0).toUpperCase() + statusText.slice(1);
  }
}

export function getAssetStatus(jobs: Record<string, JobType>) {
  const pipelineStatuses = [
    jobs[Pipeline.HBBTV.key]?.status,
    jobs[Pipeline.APOLLO.key]?.status,
    jobs[Pipeline.HYDRA.key]?.status,
  ];

  if (pipelineStatuses.every(status => status === "STATUS.REVOKED")) {
    return AssetStatus.Revoked;
  }
  else if (pipelineStatuses.every(status => status === "STATUS.FAILED")) {
    return AssetStatus.RevokeFailed;
  }
  else {
    return AssetStatus.Active;
  }
}
